import SectionHeading from "@/components/base/SectionHeading";
import VideoCard from "@/components/base/VideoCard";
import { getHotByType } from "@/utils/video";
import type { VideoType } from "@/types/video";
import { VIDEO_TYPE_LABEL } from "@/types/video";

interface HotSectionProps {
  type: VideoType;
  subtitle: string;
}

export default function HotSection({ type, subtitle }: HotSectionProps) {
  const list = getHotByType(type, 4);

  return (
    <section className="mx-auto w-full px-4 py-6 md:px-6 md:py-8 lg:px-10">
      <SectionHeading
        title={`热门${VIDEO_TYPE_LABEL[type]}`}
        subtitle={subtitle}
        moreTo={`/category/${type}`}
        accent={type === "tv" ? "accent" : type === "variety" ? "secondary" : "primary"}
      />
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {list.map((video, i) => (
          <VideoCard key={video.id} video={video} index={i} />
        ))}
      </div>
    </section>
  );
}